import { styled, alpha } from '@mui/material/styles';
import { Box, Autocomplete } from '@mui/material';

const primaryNeutralsDark10 = '#003e471a';
const primaryDark40 = 'rgba(0, 62, 71, 0.4)';

export const Container = styled(Box)(({ theme }) => ({
  '& .MuiAutocomplete-root': {
    width: '100%',

    '& .MuiInputBase-root': {
      paddingLeft: '0.625rem',
      paddingTop: '0.25rem',
      paddingBottom: '0.25rem',

      '&.Mui-focused fieldset': {
        borderColor: primaryNeutralsDark10,
        borderWidth: '1px',
      },
    },

    '& input': {
      '&::placeholder': {
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '14px',
        color: primaryDark40,
        opacity: 1,
      },
    },

    '& fieldset': {
      borderColor: primaryNeutralsDark10,
    },
  },

  '& .MuiAutocomplete-listbox': {
    maxHeight: '13rem',
    padding: '0.25rem',
    fontSize: '0.875rem',

    '& .MuiAutocomplete-option': {
      padding: '0.75rem 1rem',
    },
  },

  '& .MuiAutocomplete-paper': {
    borderRadius: '4px',
    boxShadow: '0 7px 25px 0 rgba(0, 0, 0, 0.25)',
  },
}));

export const StyledMuiAutocomplete = styled(Autocomplete)(({ theme }) => ({
  // You can also put styles directly on the Autocomplete here if preferred
})) as typeof Autocomplete;
